module.exports = __webpack_public_path__ + "static/img/game-logo-simpleplay.38c411c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-simpleplay.png
// module id = hKfV
// module chunks = 0 1 2 3 4 5 6